import PropTypes from 'prop-types';

export default PropTypes.shape({
  origin: PropTypes.string,
  destination: PropTypes.string,
  direction: PropTypes.string,
  departureDate: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      passengerId: PropTypes.string,
      tariffCode: PropTypes.string,
      price: PropTypes.number
    })
  )
});
